import { CanDeactivateFn } from '@angular/router';

export interface CompositionLeaveGuarded {
  canLeaveComposition: () => boolean | Promise<boolean>;
}

export const compositionUnsavedChangesGuard: CanDeactivateFn<CompositionLeaveGuarded> = (component) =>
  component.canLeaveComposition();
